import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CalendarDays } from 'lucide-react';
import { CalendarGrid } from '@/components/calendar/calendar-grid';

const searchSchema = z.object({
  view: z.enum(['month', 'week']).optional(),
  workspace_id: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/calendar')({
  validateSearch: searchSchema,
  component: CalendarPage,
});

function CalendarPage() {
  const { view, workspace_id } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <div className="flex h-full flex-col space-y-4">
      <h1 className="flex items-center gap-2 text-xl font-bold tracking-tight">
        <CalendarDays className="h-5 w-5" />
        Calendar
      </h1>
      <CalendarGrid
        crossWorkspace
        filterWorkspaceId={workspace_id}
        view={view || 'month'}
        onViewChange={(v) => navigate({ search: (prev) => ({ ...prev, view: v }) })}
      />
    </div>
  );
}
